<template>
    <div class="more">
        <div class="more-title">
            <div class="title">
                <span class="txt">更多解决方案</span>
            </div>
        </div>
        <div class="cases">
            <div class="case-item" v-if="moreid != item.id" v-for="(item,index) in List" :key="index" @click="caseTtem(item.path)">
                <div class="title">{{item.title}}</div>
                <div class="desc">{{item.desc}}</div>
                <div class="arrow"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        moreid: {
            type: Number,
        },
    },
    data() {
        return {
            id: "",
            List: [
                {
                    title: '营销活动平台',
                    desc: '营销活动一站搭建',
                    path: "/hdcrm",
                    id: 1
                },
                {
                    title: 'H5快易搭',
                    desc: '轻松快速制作长图文',
                    path: "/h5crm",
                    id: 2
                },
                {
                    title: '推客平台',
                    desc: '裂变营销利器，助推业务增量直线提升',
                    path: "/pmr",
                    id: 3
                },
                {
                    title: '企微SCRM',
                    desc: '私域流量运营解决方案',
                    path: "/scrm",
                    id: 4
                },
                {
                    title: '专区速搭',
                    desc: '快速搭建多功能专区',
                    path: "/cube",
                    id: 5
                },
                {
                    title: '数据分析平台',
                    desc: '驱动业务转化的营销数据分析平台',
                    path: "/datacrm",
                    id: 6
                },
            ]
        };
    },
    created() {
        this.id = this.moreid;
        console.log(this.id);
    },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {},
        caseTtem(path){
            this.$router.push(path);
        }
    },
};
</script>
<style scoped>
@import "../../static/chunk-hdcrm.css";
</style>


// WEBPACK FOOTER //
// src/components/more.vue